<script setup lang="ts">
import MainLayout from "views/layouts/MainLayout.vue";
</script>

<template>
  <MainLayout #="{ showModalMessages }">
    <div class="slot-body">
      <PhotoShooting :card-principal="cardPrincipal" :ultimos-cards="ultimosCards" />
    </div>
  </MainLayout>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PhotoShooting from "components/HomePage/BannerPhotoShooting.vue";
import { isMobile } from "views/shared/utils/mobile";
import { mapState } from "pinia";
import { localeStore } from "stores/locale";
import api from "../../api";

export default defineComponent({
  name: "HomePreviewPage",
  components: {
    PhotoShooting
  },
  computed: {
    ...mapState(localeStore, ["locale"]),
  },
  watch: {
    locale: function () {
      this.getUltimosCards(true);
      this.getCardPrincipal(true);
    },
  },
  data() {
    return {
      ultimosCards: [],
      cardPrincipal: "",
      fixedThumb: "",
      isMobile: isMobile(),
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.getUltimosCards();
      this.getCardPrincipal();
    },
    async getCardPrincipal(changeLanguage = false) {
      api
        .get(`v1/home/getEssayPrimaryPreview?language=${this.locale}&mobile=${this.isMobile}`)
        .then(({ data }) => {
          this.cardPrincipal = data.cardPincipal;
          this.fixedThumb = data.cardPincipal?.fixedThumb;
        });
    },
    async getUltimosCards(changeLanguage = false) {
      api
        .get(`v1/home/getEssaySecondaryPreview?language=${this.locale}&mobile=${this.isMobile}`)
        .then(({ data }) => {
          this.ultimosCards = data.ultimosCards;
        });
    },
  },
});
</script>

<style scoped>
.slot-body {
  margin-top: 65px !important;  
  background-color: #fff !important;
}
/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  
}
</style>
